/**
 * Theme preloader — starts downloading the theme chunk as early as possible,
 * before React mounts. The resolved promise is consumed later by
 * useThemeInitialization so the dynamic import() is not repeated.
 */

import { DEFAULT_THEME_NAME, THEME_BRAND_MAP } from 'utils/constants';
import { getInitialParams } from 'utils/getInitialParams';

const getFormattedThemeName = (theme?: string): string => {
  if (!theme) return DEFAULT_THEME_NAME;
  const match = theme.match(/brand\d+/gm);
  return match?.length ? match[0] : theme;
};

const resolveThemeName = (): string => {
  const { brand, theme } = getInitialParams();
  const themeFromQuery = getFormattedThemeName(theme || DEFAULT_THEME_NAME);

  return THEME_BRAND_MAP[brand] || themeFromQuery || DEFAULT_THEME_NAME;
};

const themeName = resolveThemeName();

export const preloadedThemePromise: Promise<Record<string, unknown>> = import(
  /* webpackChunkName: "[request]" */
  /* webpackInclude: /brand\d+\.js$/ */
  `@betbook/modulor-brands/dist/${themeName}.js`
).catch((e) => {
  // If preload fails, return null — the hook will do its own import as fallback

  console.error(e);
  return null;
});

export const preloadedThemeName: string = themeName;
